export default __webpack_public_path__ + "static/media/GateOut.7759e355.svg";